import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import subscription from './subscription'
/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/customers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::index
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:24
* @route 'https://org.proexpert.app/org/customers'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
export const show = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/customers/{user}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
show.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return show.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
show.get = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
show.head = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
const showForm = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
showForm.get = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerController::show
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerController.php:61
* @route 'https://org.proexpert.app/org/customers/{user}'
*/
showForm.head = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerResetController::reset
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerResetController.php:14
* @route 'https://org.proexpert.app/org/customers/{user}/reset'
*/
export const reset = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(args, options),
    method: 'post',
})

reset.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/customers/{user}/reset',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerResetController::reset
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerResetController.php:14
* @route 'https://org.proexpert.app/org/customers/{user}/reset'
*/
reset.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return reset.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerResetController::reset
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerResetController.php:14
* @route 'https://org.proexpert.app/org/customers/{user}/reset'
*/
reset.post = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerResetController::reset
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerResetController.php:14
* @route 'https://org.proexpert.app/org/customers/{user}/reset'
*/
const resetForm = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Customers\Presentation\Http\Controllers\OrgCustomerResetController::reset
* @see app/Domain/Customers/Presentation/Http/Controllers/OrgCustomerResetController.php:14
* @route 'https://org.proexpert.app/org/customers/{user}/reset'
*/
resetForm.post = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(args, options),
    method: 'post',
})

reset.form = resetForm

const customers = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    reset: Object.assign(reset, reset),
    subscription: Object.assign(subscription, subscription),
}

export default customers